import { Dialog, DialogActions, DialogContent, Grid, TextField, Typography } from '@mui/material';
import { MprcButton, MprcDialogTitleClose, MprcRequestErrorDialog, MprcRequestIndicator, MprcTextMuted } from 'components';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
    name: string;
    onClose: (saved: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////


export const UserProfileRequestConnectionDialog: React.FC<IProps> = (props) => {
    const { userId, name, onClose } = props;

    const { t } = useTranslation("knowledge");
    const api = useCoreApi();
    const { enqueueSnackbar } = useSnackbar();

    const [message, setMessage] = useState<string>();
    const [viewError, setViewError] = useState<any>(null);
    const [saving, setSaving] = useState<boolean>(false);

    ///
    const handleSave = () => {
        setSaving(true);
        api.v1.knowledgeSubcription.profileRequestConnection({ userId, message: message ?? "" })
            .then(result => {
                if (result.data === true) {
                    enqueueSnackbar(t("Feed.UserProfile.RequesConnectionDialog.SuccessMessage"), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Error.PostFailed", { ns: "shared" }), { variant: "error" });
                }
            })
            .catch(e => setViewError(e))
            .finally(() => setSaving(false));
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (<Dialog
        open
        onClose={() => onClose(null)}
        maxWidth="xs"
        fullWidth
    >
        <MprcDialogTitleClose
            title={t("Feed.UserProfile.RequesConnectionDialog.TitleView")}
            subtitle={name}
            onClose={() => onClose(null)}
            shrinkPadding
        />
        <DialogContent>
            <MprcRequestIndicator type="post" visible={saving} />
            <MprcRequestErrorDialog error={viewError} onClose={() => setViewError(null)} />
            <TextField
                autoFocus
                value={message}
                placeholder={t("Feed.UserProfile.RequesConnectionDialog.MessagePlaceholder")}
                multiline={true}
                rows={10}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
                variant="outlined"
            />

            <Grid container direction="column" spacing={2}>
                <Grid>
                    <MprcTextMuted>
                        <Typography variant="caption" component="p">
                            {t("Feed.UserProfile.RequesConnectionDialog.Tooltip_L1")}
                        </Typography>
                    </MprcTextMuted>
                </Grid>
                <Grid>
                    <MprcTextMuted>
                        <Typography variant="caption" component="p">
                            {t("Feed.UserProfile.RequesConnectionDialog.Tooltip_L2")}
                        </Typography>
                        <Typography variant="caption" component="p">
                            {t("Feed.UserProfile.RequesConnectionDialog.Tooltip_L3")}
                        </Typography>
                        <Typography variant="caption" component="p">
                            {t("Feed.UserProfile.RequesConnectionDialog.Tooltip_L4")}
                        </Typography>
                    </MprcTextMuted>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", alignItems: "center" }}>
            <MprcButton
                text={t("Feed.UserProfile.RequesConnectionDialog.RequestConnectionButtonText")}
                title={t("Feed.UserProfile.RequesConnectionDialog.RequestConnectionButtonTitle")}
                color="success"
                variant="contained"
                onClick={handleSave}
                disabled={saving}
            />
        </DialogActions>
    </Dialog>);
};
